import { UIText3 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './ChatListItemSwipeButton.css';
// @ts-expect-error TODO: исправить импорт картинок
import archiveImg from './assets/archive.svg';
// @ts-expect-error TODO: исправить импорт картинок
import deleteImg from './assets/delete.svg';
// @ts-expect-error TODO: исправить импорт картинок
import readImg from './assets/read.svg';
// @ts-expect-error TODO: исправить импорт картинок
import returnImg from './assets/return.svg';
// @ts-expect-error TODO: исправить импорт картинок
import unblockImg from './assets/unblock.svg';
// @ts-expect-error TODO: исправить импорт картинок
import unreadImg from './assets/unread.svg';

export enum EChatListItemSwipeButtonType {
  Archive = 'archive',
  Delete = 'delete',
  Read = 'read',
  Return = 'return',
  Unblock = 'unblock',
  Unread = 'unread',
}

type TButtonInfo = {
  image: string;
  text: string;
  color: string;
};

const ButtonsInfo: { [key in EChatListItemSwipeButtonType]: TButtonInfo } = {
  [EChatListItemSwipeButtonType.Archive]: {
    text: 'В архив',
    image: archiveImg,
    color: 'gray',
  },
  [EChatListItemSwipeButtonType.Delete]: {
    text: 'Удалить',
    image: deleteImg,
    color: 'red',
  },
  [EChatListItemSwipeButtonType.Read]: {
    text: 'Прочитано',
    image: readImg,
    color: 'gray',
  },
  [EChatListItemSwipeButtonType.Return]: {
    text: 'Вернуть',
    image: returnImg,
    color: 'gray',
  },
  [EChatListItemSwipeButtonType.Unblock]: {
    text: 'Разблокировать',
    image: unblockImg,
    color: 'blue',
  },
  [EChatListItemSwipeButtonType.Unread]: {
    text: 'Не прочитано',
    image: unreadImg,
    color: 'blue',
  },
};

type TChatListItemSwipeButtonProps = {
  type: EChatListItemSwipeButtonType;
  onClick(type: EChatListItemSwipeButtonType): void;
};

export const ChatListItemSwipeButton: React.VFC<TChatListItemSwipeButtonProps> = ({ type, onClick }) => {
  const { text, color, image } = ButtonsInfo[type];

  const onClickHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick(type);
  };

  return (
    <button onClick={onClickHandler} className={classNames(styles['button'], styles[color])}>
      <img src={image} width={24} height={24} />
      <UIText3 color="white_100" whiteSpace="nowrap">
        {text}
      </UIText3>
    </button>
  );
};
